<template>
	<div>
        <div class="u-margin-bottom-10 u-margin-right-20 flex-state-buttons" v-if="filterHeading.length">
            {{ filterHeading }}
        </div>
        <div class="a-form-inputs--half a-form-inputs--half-to">
            <div class="a-form-inputs__container">
                <input autocomplete="off" v-model="from" @input="updateValue($event)" ref="inputFrom">
            </div>
            <div class="a-form-inputs__to">to</div>
            <div class="a-form-inputs__container">
                <input autocomplete="off" v-model="to" @input="updateValue($event)" ref="inputTo">
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: 'RangeFilter',
        props: {
        	filterHeading: {
        		type: String,
        		default: ''
        	},
            id: {
                type: Number,
                default: 0
            },
            name: {
                type: String,
                default: ''
            },
            // Callback
            update: {},
        },
        data () {
            return {
                from: '',
                to: '',
            };
        },
        methods: {
            updateValue() {
                this.update({key: this.name, value: [this.from, this.to]});
            },
            reset() {
                this.update({key: this.name, value: [null, null]});
                this.$refs.inputFrom.value = null;
                this.$refs.inputTo.value = null;
            },
        }
    }

</script>


// WEBPACK FOOTER //
// RangeFilter.vue?42415368